import { render } from "./Incidence_reports.vue?vue&type=template&id=510d7e33"
import script from "./Incidence_reports.vue?vue&type=script&lang=js"
export * from "./Incidence_reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__